import { Box } from "@mui/material";
import {
  ArrayField,
  Datagrid,
  FunctionField,
  TextField,
  useRecordContext,
} from "react-admin";
import { settings } from "app";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import {
  DoctorantReportProtocolTypeChoices,
  DoctorantReportStatusChoices,
  DoctorantReportStatusColorMap,
} from "utils/choices";
import { DoctorantStatus } from "utils/constants";
import StatusChip from "../../Partials/StatusChip";
import AddReportDialog from "./AddReportDialog";
import DoctoralDateField from "../../Partials/DoctoralDateField";

const protocolTypeLabel = type =>
  DoctorantReportProtocolTypeChoices.find(c => c.id === type)?.name ?? "—";

const ReportsSection = () => {
  const record = useRecordContext();
  const reports = record?.reports ?? [];

  return (
    <Box>
      {record?.status === DoctorantStatus.Active && (
        <SecuredComponent permission={permissions.canManageDoctorantReports}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <AddReportDialog />
          </Box>
        </SecuredComponent>
      )}

      {reports.length === 0 ? (
        <em>Няма данни</em>
      ) : (
        <ArrayField source="reports">
          <Datagrid bulkActionButtons={false} rowClick={false} sx={settings.style.secondaryDatagrid}>
            <FunctionField
              label="Вид отчет"
              render={r => protocolTypeLabel(r.protocolType)}
            />
            <DoctoralDateField source="protocolDate" label="Дата на протокола" />
            <TextField source="protocolNumber" label="Номер на протокола" />
            <FunctionField
              label="Статус"
              render={r => (
                <StatusChip
                  status={r.status}
                  choices={DoctorantReportStatusChoices}
                  colorMap={DoctorantReportStatusColorMap}
                />
              )}
            />
            <DoctoralDateField source="createdOn" label="Създаден на" />
          </Datagrid>
        </ArrayField>
      )}
    </Box>
  );
};

export default ReportsSection;
